import apis from '@api/client';
import { useRegisterContext } from '@contexts/RegisterProvider';
import { useMutation } from '@tanstack/react-query';

import { resolveCommonError } from '../utils/errorCodeUtils';

export function useValidateRegistrationCodeMutation({
  onSuccess,
  onError,
}: {
  onSuccess: () => void;
  onError: (errorInfo: { commonErrorCode?: string; isExpired?: boolean }) => void;
}) {
  const { updateRegistrationCode, updateCompanyId } = useRegisterContext();

  return useMutation({
    mutationFn: async (enteredCode: string) => {
      return await apis.registration
        .validateRegistrationCode(
          { validateRegistrationCodeRequest: { registrationCode: enteredCode } },
          { headers: { Authorization: undefined } },
        )
        .then(res => res.data);
    },
    onSuccess: (data, enteredCode) => {
      if (data.isValid) {
        updateRegistrationCode(enteredCode);
        updateCompanyId(data.companyId);
        onSuccess();
      } else {
        updateRegistrationCode(undefined);
        updateCompanyId(undefined);
        onError({ isExpired: data.isExpired });
      }
    },
    onError: err => {
      updateRegistrationCode(undefined);
      updateCompanyId(undefined);
      onError({ commonErrorCode: resolveCommonError(err) });
    },
  });
}
